import { AxiosInstance, AxiosRequestConfig } from "axios";
import http from "../Http";
import { ProcessHierarchField } from "../../../../core/grids/builder/directorBuilder/utils/GridFields";
import { IFlightPathApiResponse } from "../BaseApiModel";
import { ExportableOrganisationApi } from "../exportableApi/ExportableOrganisationApiModel";

export class ProcessesApi extends ExportableOrganisationApi<any> {
  controller: string = "processes";

  constructor(http: AxiosInstance) {
    super(http, "processes");
  }

  updateField = async (
    organisationId: number,
    projectId: number = null,
    processId: number,
    textField: string,
    idField: number,
    dateField: Date,
    numericField: number,
    processField: ProcessHierarchField,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<boolean>> => {
    let data = {
      TextField: textField,
      IdField: idField,
      DateField: dateField,
      NumericField: numericField
    };
    let res = await this.http.put(
      `${this.url}/${organisationId}/${this.controller}/${processId}/${processField}`,
      data,
      config
    );
    return res.data;
  };

  createOrganisationProcess = async (organisationId: number, data: any, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}`;
    let res = await this.http.post(url, data, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  createFromFlatList = async (organisationId: number, data: any[], config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/${this.controller}/create-from-flat-list`;
    let res = await this.http.post(url, data, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  getAll = async (organisationId: number, config?: any) => {
    let res = await this.http.get(`${this.url}/${organisationId}/${this.controller}`, config);
    return res.data;
  };

  deleteRange = async (organisationId: number, projectId: number, ids: number[], config?: AxiosRequestConfig) => {
    let res = await this.http.post(`${this.url}/${organisationId}/${this.controller}/delete-range`, ids, config);
    return res.data;
  };
}

const instance = new ProcessesApi(http);
export default instance;
